var map = {
	"./AssignTagTruck.png": 2870,
	"./ZoneMapImageIcon.png": 2871,
	"./assetSummary.png": 2872,
	"./barChart.png": 2873,
	"./battery.png": 2874,
	"./batteryExchange.png": 2875,
	"./batteryLevel.png": 2876,
	"./cages.png": 2877,
	"./deployment.png": 2878,
	"./distribution.png": 2879,
	"./favouriteAssets.png": 2880,
	"./favouritePeople.png": 2881,
	"./favouriteZone.png": 2882,
	"./floorplan.png": 2883,
	"./guage.png": 2884,
	"./hours.png": 2885,
	"./lifecycle.png": 2886,
	"./lineChart.png": 2887,
	"./map.png": 2888,
	"./peopleSummary.png": 2889,
	"./recentItem.png": 2890,
	"./zoneSummary.png": 2891,
	"./zonemap.png": 2892
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;